/* eslint react/prop-types: 0 */
import styled from 'styled-components';
import Header from './Header';
import AppContainer from '../Components/AppContainer';
import LayoutContainer from '../Components/Container';

const ContentContainer = styled(AppContainer)`
  min-height: calc(100vh - 56px);
  grid-auto-rows: max-content;
  ${({ theme }) => `${theme.breakpoints.down('tablet')} {
      width: 768px;
      padding: 0 20px;
    };`}
  ${({ theme }) => `${theme.breakpoints.down('mobile')} {
      width: 100%;
      padding: 0 16px;
      grid-template-columns: repeat(8, 1fr);
      grid-column-gap: 8px;
      margin-top: 16px;
      grid-row-gap: 8px;
    };`}
`;

const LayHeader = styled(Header)`
  background: ${({ $shadow }) => ($shadow && '#fff') || 'initial'};
  box-shadow: ${({ $shadow }) =>
    ($shadow && '0px 16px 32px #f0f4f7') || 'initial'};
`;

const Layout = ({ children, className, shadow }) => {
  return (
    <LayoutContainer className={className}>
      <LayHeader $shadow={shadow} />
      <ContentContainer className="container">{children}</ContentContainer>
    </LayoutContainer>
  );
};

export default Layout;
